import {reportsService} from '../services/reportsService';
import moment from "moment"

const state = {
  categories: [],
  reports: [],
  reportsLists: [],
  currentCategoryId: 'all',
  reportUrl: null,
  dateRange: null,
  dateTitleLabel:'',
  currentReport: {},
  isUpgradeMode: null
};

const mutations = {
  setReportsLists(state, reportsLists){
    state.reportsLists = reportsLists
  },
  setCategories(state, categories){
    state.categories = categories
  },
  setCurrentCategory(state, categoryId){
    state.currentCategoryId = categoryId
  },
  setDateRange(state, dateRange){
    state.dateRange = dateRange
  },
  setReportUrl(state, reportUrl) {
    state.reportUrl = reportUrl;
  },
  setCurrentReport(state, currentReport){
    state.currentReport = currentReport
  },
  setDateTitleLabel(state, dateTitleLabel){
    state.dateTitleLabel = dateTitleLabel
  },
  setUpgradeMode(state, status) {
    state.isUpgradeMode = status
  }
};

const actions = {
  //  START SPECIAL SCENARIO FOR CORRUPTED-DOCUMENT-REPORT
  async fetchDocumentsReportData({commit, dispatch},{payload}) {
    try{
      const currentReport = {
        // optional - if exist will shown after the description
        // help_center: "https://support.vcita.com/hc/en-us/articles/4407517600407#slide-2",
        // do not change the name - this is the translations key name
        name: "corrupted_document_report",
        provider: window?.app_config?.Environment === "integration" ? "https://looker-embed.apps.meet2know.com/" : "https://looker-embed.apps.vcita.com/"
      }
      commit('setCurrentReport', currentReport)
      const appConfig = window.app_config
      let provider = "https://looker-embed.apps.vcita.com/"
      let documentsReportId = 20
      let reportUrl = provider +
        "?report_id=" + documentsReportId +
        "&locale=" + payload.locale +
        "&brand_host=" + appConfig.frontage_location +
        "&report_type=dashboards&first_name=" + payload.firstName
      commit('setReportUrl', reportUrl)
    } catch(e){
      console.error('error', e);
    }
  },
  //  END SPECIAL SCENARIO FOR CORRUPTED-DOCUMENT-REPORT
  async fetchPaymentReportData({commit, dispatch}, {payload}) {
    try{
      const currentReport = {
        name: payload.name,
        hide_updated_at: true,
        provider: window?.app_config?.Environment === "integration" ? "https://looker-embed.apps.meet2know.com/" : "https://looker-embed.apps.vcita.com/",
        ...(paymentReportsData[payload.name]?.helpArticle && {helpArticle: paymentReportsData[payload.name]?.helpArticle}),
      }
      commit('setCurrentReport', currentReport)
      const appConfig = window.app_config
      let provider = currentReport.provider
      const reportIdIntegration = paymentReportsData[payload.name].reportIdIntegration || -1
      const reportIdProduction = paymentReportsData[payload.name].reportIdProduction || -1
      let transactionReportId = window?.app_config?.Environment === "integration" ? reportIdIntegration : reportIdProduction
      let reportUrl = provider +
        "?report_id=" + transactionReportId +
        "&business_id=" +  payload.businessUid +
        "&locale=" + payload.locale +
        "&brand_host=" + appConfig.frontage_location +
        "&report_type=dashboards&first_name=" + payload.firstName
      commit('setReportUrl', reportUrl)
    } catch(e){
      console.error('error', e);
    }
  },
  async fetchReportsData({commit, dispatch, state, rootGetters}, {businessId}){
    try {
      //UPGRADE MODE - user that has 'reports' FF but has not 'detailed_reports' FF
      commit('setUpgradeMode', rootGetters.hasFeature('reports') && !rootGetters.hasFeature('detailed_reports'))
      if (Object.keys(state.reportsLists).length === 0) {
        let categories = []
        let reportsByCategories = (await reportsService.getReports(businessId))["report"]

        for (let category in reportsByCategories){
          categories.push({id: category, label: `report.reports.categories.${category}`})
          reportsByCategories[category].forEach(report => {
            report['icon'] = `icon-Reports-${report.type}`
            report.disabled = state.isUpgradeMode || rootGetters.isMobile && report.type == 'table'
          })
        }
        commit('setCategories', categories)
        commit('setReportsLists', reportsByCategories)
      }

    }catch (e) {
      return Promise.reject(e)
    }
  },

  updateCategory({commit}, {categoryId}){
    commit('setCurrentCategory',categoryId)
  },
  updateDateByTypeAndAmount({commit, state}, payload){
    let { type, amount} = payload.value
    let startDate = moment()
    let endDate = moment()
    if(type === 'months') {
      amount = (amount >= 1) ? amount - 1 : amount
      startDate.startOf('month')
    }
    startDate = startDate.subtract(amount, type);
    let dateRange = {
      startDate,
      endDate
    }
    commit('setDateRange',dateRange)
  },
  updateDateByDateRange({commit, state}, payload){
    let {dateFrom, dateTo} = payload
    let dateRange = {
      startDate:moment(dateFrom),
      endDate:moment(dateTo)
    }
    commit('setDateRange',dateRange)
  },

  async fetchReportDataByName({commit, dispatch},{payload}) {
    try{
      const appConfig = window.app_config
      let currentReport = state.reportsLists['all'].filter(report => report.name === payload.reportCodeName)
      commit('setCurrentReport', currentReport[0])
      let reportUrl = state.currentReport.provider +
        "?report_id=" + state.currentReport.external_id +
        "&business_id=" +  payload.businessUid +
        "&locale=" + payload.locale +
        "&brand_host=" + appConfig.frontage_location
      if (state.currentReport.external_type) {
        reportUrl += "&report_type=" + state.currentReport.external_type
      }
      if (payload.firstName) {
        reportUrl += "&first_name=" + payload.firstName
      }
      if (payload.lastName) {
        reportUrl += "&last_name=" + payload.lastName
      }
      commit('setReportUrl', reportUrl)
      await dispatch('updateDateByTypeAndAmount', {value:{type: 'months', amount: state.currentReport.monthly_time_range}})
    } catch(e){
      console.error('error', e);
    }
  },

  async updateDateForTitle({commit, dispatch},{payload}){
    if(payload.dateRange[0] === "" && payload.dateRange[1] === "" && payload.datesInterval !== ""){
      await dispatch('updateDateByTypeAndAmount',{value: payload.datesInterval.value});
      commit('setDateTitleLabel', payload.datesInterval.label)
    }
    else if(payload.datesInterval === "" && payload.dateRange[0] !== "" && payload.dateRange[1] !== ""){
      await dispatch('updateDateByDateRange',{dateFrom:payload.dateRange[0], dateTo:payload.dateRange[1]});
      commit('setDateTitleLabel', null)
    }
  }
}

const getters = {
  reportUrl: (state) => state.reportUrl,
  getCategories: (state) => state.categories,
  getReportsLists: (state) => state.reportsLists,
  getDateRange: (state) => state.dateRange,
  getCurrentReport: (state) => state.currentReport,
  getDateTitleLabel:(state) => state.dateTitleLabel,
  isUpgradeMode: (state) => state.isUpgradeMode,
  getCurrentCategoryId: (state) => state.currentCategoryId,
}

const paymentReportsData = {
  transactions_report: {
    reportIdIntegration: 18,
    reportIdProduction: 24,
    helpArticle: {
      link: `https://support.vcita.com/hc/en-us/articles/7053822572695-Getting-Started-with-Payments-by-vcita`,
      whiteLabelLink: `https://support.myclients.io/hc/en-us/articles/7695935978135-Getting-Started-with-Payments-by-vcita`,
      articleCode: 'InTandem_Payments',
      articleAnalyticsCode: 'InTandem_Payments_reports'
    },
  },
  payouts_report: {
    reportIdIntegration: 19,
    reportIdProduction: 25
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
